import $ from "jquery"
import request_body from './request_body';

function request(path, params, contentType) {
    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    return new Promise((resolve, reject)=>{
        let vo = {
            url: request_body.url + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                if (e.responseJSON.code == 403) {
                    // if (this.app.isLogout != true) {
                    //     this.app.isLogout = true;
                    //     this.app.$alert('点击返回登录', '登录过期', {
                    //         confirmButtonText: '确定',
                    //         callback: action => {
                    //             this.app.isLogout = false;
                    //             this.app.$router.push("/login");
                    //         }
                    //     });
                    // }

                    window.location.href = "/login"
                }
                reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        if (request_body.token != null && request_body.token != "") {
            vo.headers.token = request_body.token;
        }
        $.ajax(vo)
        
    })
}

export {
    request
}